import { defaultProvince } from "src/pages/AdministrativeBoundaries/utils";

export const mapProvinceToDataTable = (data, provinceId) => {
  return data.filter(
    (province) =>
      province.id === provinceId && province.id !== defaultProvince.id
  );
};

export const provinceColumns = [
  { key: "provinceName", label: "Province Name", align: "center" },
  { key: "provinceCode", label: "province Code", align: "center" },
];
